  <template>
  <div id='annual-budget'>
    <!--
    <b-modal
      :id="`yearInsufficientFundsModal-${budgetYear.year}`"
      title="Insufficient Funds"
      size="lg"
      ok-only
    >
    -->
    <b-modal
      :id="`yearInsufficientFundsWithinProjectModal-${budgetYear.year}`"
      title="Insufficient Funds"
      size="xl"
      @ok="onAnnualBudgetInsufficientFundsDismiss(budgetYear)"
      @cancel="onAnnualBudgetInsufficientFundsOverride(budgetYear)"
    >
      <p>There are insufficient funds APPROVED TO SPEND from the following funding source(s) within this Project:</p>
      <!-- <p>Please make adjustments to amounts being requested, funding sources used, and/or increase the available funds for the funding sources used.</p> -->

      <b-row>
        <b-col cols='2' class='insufficient-funds-header'>Funding Source</b-col>
        <b-col>
          <b-row>
            <b-col cols='2' class='insufficient-funds-header insufficient-funds-numeric'>
              Total Approved Funding
            </b-col>
            <b-col cols='2' class='insufficient-funds-header insufficient-funds-numeric'>
              Encumbered within this Project
            </b-col>
            <b-col cols='2' class='insufficient-funds-header insufficient-funds-numeric'>
              Remaining
            </b-col>
            <b-col cols='2' class='insufficient-funds-header insufficient-funds-numeric'>
              Requested for this Annual Budget
            </b-col>
            <b-col cols='2' class='insufficient-funds-header insufficient-funds-numeric'>
              Difference
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row v-for="item in insufficientFundingSources" :key="item.fundingSourceName">
        <b-col cols='2'>{{item.fundingSourceName}}</b-col>
        <b-col>
          <b-row>
            <b-col cols='2' class='insufficient-funds-numeric'>{{item.totalApprovedFunding | toCurrency}}</b-col>
            <b-col cols='2' class='insufficient-funds-numeric'>{{item.encumberedInProject | toCurrency}}</b-col>
            <b-col cols='2' class='insufficient-funds-numeric'>{{item.remaining | toCurrency}}</b-col>
            <b-col cols='2' class='insufficient-funds-numeric'>{{item.requested | toCurrency}}</b-col>
            <b-col cols='2' class='insufficient-funds-numeric'>{{item.difference | toCurrency}}</b-col>
          </b-row>
        </b-col>
      </b-row>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="ok" class='btn-success'>Dismiss</b-button>
        <b-button size="sm" variant="danger" @click="cancel" class='btn-danger'>Override</b-button>
      </template>
    </b-modal>
    <b-modal
      :id="`yearInsufficientFundsAcrossProjectModal-${budgetYear.year}`"
      title="Insufficient Funds"
      size="xl"
      @ok="onAnnualBudgetInsufficientFundsDismiss(budgetYear)"
      @cancel="onAnnualBudgetInsufficientFundsOverride(budgetYear)"
    >
      <p>There are insufficient funds in the following funding source(s) to fund this Annual Budget:</p>
      <!-- <p>Please make adjustments to amounts being requested, funding sources used, and/or increase the available funds for the funding sources used.</p> -->

      <b-row>
        <b-col cols='2' class='insufficient-funds-header'>Funding Source</b-col>
        <b-col>
          <b-row>
            <b-col cols='2' class='insufficient-funds-header insufficient-funds-numeric'>
              Total "Approved Projects Budgets"
            </b-col>
            <b-col cols='2' class='insufficient-funds-header insufficient-funds-numeric'>
              Encumbered across all Projects
            </b-col>
            <b-col cols='2' class='insufficient-funds-header insufficient-funds-numeric'>
              Remaining
            </b-col>
            <b-col cols='2' class='insufficient-funds-header insufficient-funds-numeric'>
              Requested for this Annual Budget
            </b-col>
            <b-col cols='2' class='insufficient-funds-header insufficient-funds-numeric'>
              Difference
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row v-for="item in insufficientFundingSourcesAcrossProjects" :key="item.fundingSourceName">
        <b-col cols='2'>{{item.fundingSourceName}}</b-col>
        <b-col>
          <b-row>
            <b-col cols='2' class='insufficient-funds-numeric'>{{item.totalApprovedProjectsBudget | toCurrency}}</b-col>
            <b-col cols='2' class='insufficient-funds-numeric'>{{item.encumberedAcrossProjects | toCurrency}}</b-col>
            <b-col cols='2' class='insufficient-funds-numeric'>{{item.remaining | toCurrency}}</b-col>
            <b-col cols='2' class='insufficient-funds-numeric'>{{item.requested | toCurrency}}</b-col>
            <b-col cols='2' class='insufficient-funds-numeric'>{{item.difference | toCurrency}}</b-col>
          </b-row>
        </b-col>
      </b-row>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="ok" class='btn-success'>Dismiss</b-button>
        <b-button size="sm" variant="danger" @click="cancel" class='btn-danger'>Override</b-button>
      </template>
    </b-modal>
    <b-modal
      :id="`submitProjectBudgetModal-${budgetYear.year}`"
      title="Confirm Project Budget Submittal"
      @ok="submitAnnualBudget(budgetYear)">
      <p>Once submitted, you will not be able to make further edits to this annual budget unless
        the budget is rejected by the manager.</p>
      <p>Are you sure you want to submit this budget for approval?</p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="cancel" class='btn-danger'>No</b-button>
        <b-button size="sm" variant="success" @click="ok" class='btn-success'>Yes</b-button>
      </template>
    </b-modal>
    <b-modal
      :id="`rejectProjectBudgetModal-${budgetYear.year}`"
      title="Confirm Project Budget Rejection"
      @ok="rejectAnnualBudget(budgetYear)">
      <p>Rejected annual budgets are editable and can be re-submitted if appropriate.</p>
      <p>Are you sure you want to reject this annual budget?</p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="cancel" class='btn-danger'>No</b-button>
        <b-button size="sm" variant="success" @click="ok" class='btn-success'>Yes</b-button>
      </template>
    </b-modal>
    <b-modal
      :id="`approveProjectBudgetModal-${budgetYear.year}`"
      title="Confirm Project Budget Approval"
      @ok="approveAnnualBudget(budgetYear)">
      <p>
        Approved annual budgets are not editable and expenditures on this project in this year
        may not exceed this approved amount. A Manager can reject this budget if it needs to be
        edited.
      </p>
      <p>Are you sure you want to approve this annual budget?</p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="cancel" class='btn-danger'>No</b-button>
        <b-button size="sm" variant="success" @click="ok" class='btn-success'>Yes</b-button>
      </template>
    </b-modal>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header card-header-with-nested-tables">
            <a v-b-toggle="`budget-${budgetYear.year}-card`" class="c-pointer">
              <b-icon icon='caret-right-fill' class="when-closed" />
              <b-icon icon='caret-down-fill' class="when-opened" />
              <span class="details-label"> {{ budgetYear.year }}</span> ({{ budgetYear.status }})
            </a>
            <!-- eslint-disable-next-line -->
            <b-link v-if="isYearEditable(budgetYear)" class="add-link" @click="openCostItemModal(budgetYear)">
              <b-icon icon="plus"></b-icon>
              Add Cost Item
            </b-link>
          </div>
          <b-modal
            :id="`costItemModal-${budgetYear.year}`"
            :title="currentLineItem.id ? 'Edit Cost Item' : 'New Cost Item'"
            @hidden="cancelCostItem"
            size="xl">
            <b-alert
              :show="warningDismissCountDown"
              dismissible
              @dismissed="warningDismissCountDown=0"
              @dismiss-count-down="warningCountDownChanged"
              variant="danger"
            >
              {{ errorMessage }}
            </b-alert>
            <LoadingSpinner v-if='loadingPriceBookData' message ='Loading Price Book Data' size = '1x'/>
            <VueFormGenerator v-else
              :schema="getSchema()"
              :model="currentLineItem"
              :options="{
                validateAfterLoad: validateAfterLoad,
                validateAfterChanged: true,
                validateAsync: true
              }"
              @validated="onLineItemValidation"
            />
            <template v-slot:modal-footer>
              <b-button
                size="sm"
                variant="danger"
                @click="$bvModal.hide(`costItemModal-${budgetYear.year}`)"
                class='management-plan-dialog-no'>
                Cancel
              </b-button>
              <b-button
                :disabled="!validForm"
                size="sm"
                variant="success"
                @click="addItem(budgetYear)"
                class='management-plan-dialog-yes'>
                <template v-if="currentLineItem.id">
                  Update Cost Item
                </template>
                <template v-else>
                  Add Item
                </template>
              </b-button>
            </template>
          </b-modal>
          <b-collapse :id="`budget-${budgetYear.year}-card`" visible>
            <b-overlay :show="processingApproval">
              <div class="card-body">
                <AnnualBudgetIncreaseModal :budgetYear=budgetYear />
                <b-tabs content-class="mt-3" nav-wrapper-class="budget-tabs" pills>
                  <b-tab
                    v-if="showAnnualExpenditureSummary()"
                    title="Expenditure Summary">
                    <b-overlay :show="!processingApproval && !projectBudgetSummaryDataLoaded">
                      <div class="row">
                        <div class="col-12">
                          <b-button
                            v-if='canCreateWorkorder(budgetYear)'
                            :disabled="workorderLookupsLoading"
                            pill
                            size="sm"
                            variant="primary"
                            class="float-right-button action-button"
                            @click='onWorkorderAddClick(budgetYear)'
                          >
                            <span>Create Work Order</span>
                          </b-button>
                        </div>
                      </div>
                      <b-alert
                        :show="successDismissCountDown"
                        dismissible
                        variant="success"
                        @dismissed="successDismissCountDown=0"
                        @dismiss-count-down="successCountDownChanged"
                      >
                        Line Item successfully posted.
                      </b-alert>
                      <template v-if='showProjectBudgetSummary'>
                        <div class='row'>
                          <div class="col-12 list-item-title">Summary</div>
                        </div>
                        <b-card class='col-6 list-item-table'>
                          <div class='row'>
                            <div class="col-6 details-label">Total Annual Cost</div>
                            <div class="col-6 text-right">
                              {{ getAnnualBudgetExpenditureTotalAnnualCost(budgetYear) | toCurrency }}
                            </div>
                          </div>

                          <hr/>
                          <div class='row'>
                            <div class="col-6 details-label">Cost Share</div>
                            <div class="col-6 text-right">
                              {{ getAnnualBudgetExpenditureCostShare(budgetYear) | toCurrency }}
                            </div>
                          </div>
                          <hr/>

                          <div class='row'>
                            <div class="col-6 details-label">
                              <a v-b-toggle="`expenditure-summary-district-partner-obligated-${budgetYear.year}-collapse`" class="c-pointer">
                                <b-icon icon='caret-right-fill' class="when-closed" />
                                <b-icon icon='caret-down-fill' class="when-opened" />
                                <span>District or Partner Cost</span>
                              </a>
                            </div>
                            <div class="col-6 text-right">
                              {{ getAnnualBudgetExpenditureDistrictAndPartner(budgetYear) | toCurrency }}
                            </div>
                          </div>

                          <b-collapse :id="`expenditure-summary-district-partner-obligated-${budgetYear.year}-collapse`">
                            <hr/>
                            <div class='row'>
                              <div class="col-6 details-label">
                                <a
                                  v-b-toggle=
                                  "`expenditure-summary-district-partner-obligated-spent-${budgetYear.year}-collapse`"
                                  class="c-pointer">
                                  <b-icon icon='caret-right-fill' class="when-closed" />
                                  <b-icon icon='caret-down-fill' class="when-opened" />
                                  <span>Total Obligated</span>
                                </a>
                              </div>
                              <div class="col-6 text-right">
                                {{ getAnnualBudgetExpenditureTotalObligated(budgetYear.year) | toCurrency }}
                              </div>
                            </div>

                            <b-collapse :id="`expenditure-summary-district-partner-obligated-spent-${budgetYear.year}-collapse`">
                            <hr/>
                            <div class='row'>
                              <div class='col-1'></div>
                              <div class="col-5 details-label">
                                <a v-b-toggle="`expenditure-summary-district-partner-obligated-spent-items-${budgetYear.year}-collapse`" class="c-pointer">
                                  <b-icon icon='caret-right-fill' class="when-closed" />
                                  <b-icon icon='caret-down-fill' class="when-opened" />
                                  <span>Obligated Spent</span>
                                </a>
                              </div>
                              <div class="col-6 text-right">
                                {{ getAnnualBudgetExpenditureObligatedSpent(budgetYear.year) | toCurrency }}
                              </div>
                            </div>
                            <b-collapse :id="`expenditure-summary-district-partner-obligated-spent-items-${budgetYear.year}-collapse`">
                              <hr/>
                              <b-row v-for="item in getAnnualBudgetExpenditureObligatedSpentItems(budgetYear.year)" :key="item.name">
                                <div class='col-2'></div>
                                <div class="col-5">{{item.name}}</div>
                                <div class="col-5 text-right">
                                  {{ item.total | toCurrency }}
                                </div>
                              </b-row>
                            </b-collapse>
                            <hr/>

                            <div class='row'>
                              <div class='col-1'></div>
                              <div class="col-5 details-label">
                                <a v-b-toggle="`expenditure-summary-district-partner-obligated-unspent-items-${budgetYear.year}-collapse`" class="c-pointer">
                                  <b-icon icon='caret-right-fill' class="when-closed" />
                                  <b-icon icon='caret-down-fill' class="when-opened" />
                                  <span>Obligated Unspent</span>
                                </a>
                              </div>
                              <div class="col-6 text-right">
                                {{ getAnnualBudgetExpenditureObligatedUnspent(budgetYear.year) | toCurrency }}
                              </div>
                            </div>
                            <b-collapse :id="`expenditure-summary-district-partner-obligated-unspent-items-${budgetYear.year}-collapse`">
                              <hr/>
                              <b-row v-for="item in getAnnualBudgetExpenditureObligatedUnspentItems(budgetYear.year)" :key="item.name">
                                <div class='col-2'></div>
                                <div class="col-5">{{item.name}}</div>
                                <div class="col-5 text-right">
                                  {{ item.total | toCurrency }}
                                </div>
                              </b-row>
                            </b-collapse>
                          </b-collapse>

                          <hr/>
                          <div class='row'>
                              <div class="col-6 details-label">
                                <a v-b-toggle="`expenditure-summary-district-partner-remaining-items-${budgetYear.year}-collapse`" class="c-pointer">
                                  <b-icon icon='caret-right-fill' class="when-closed" />
                                  <b-icon icon='caret-down-fill' class="when-opened" />
                                  <span>Total Remaining</span>
                                </a>
                              </div>
                              <div class="col-6 text-right">
                                {{ getAnnualBudgetExpenditureTotalRemaining(budgetYear) | toCurrency }}
                              </div>
                            </div>
                            <b-collapse :id="`expenditure-summary-district-partner-remaining-items-${budgetYear.year}-collapse`">
                              <hr/>
                              <b-row v-for="item in getAnnualBudgetExpenditureTotalRemainingItems(budgetYear)" :key="item.name">
                                <div class='col-2'></div>
                                <div class="col-5">{{item.name}}</div>
                                <div class="col-5 text-right">
                                  {{ item.total | toCurrency }}
                                </div>
                              </b-row>
                            </b-collapse>

                        </b-collapse>
                        </b-card>
                      </template>
                    </b-overlay>
                  </b-tab>
                  <b-tab title="Scope of Work">
                    <div class="row">
                      <div class="col-12 list-item-title">
                        Services
                        <b-button
                          v-if="canApproveRejectAnnualBudget(budgetYear)"
                          pill size="sm" variant="primary" class="float-right-button action-button"
                          @click="validateAnnualBudgetForApproval(budgetYear)">
                          Approve
                        </b-button>
                        <b-button
                          v-if="canApproveRejectAnnualBudget(budgetYear)"
                          pill size="sm" variant="danger" class="float-right-button action-button"
                          v-b-modal="`rejectProjectBudgetModal-${budgetYear.year}`">
                          Reject
                        </b-button>
                        <b-button
                          v-if="canSubmitAnnualBudget(budgetYear)"
                          pill size="sm" variant="primary" class="float-right-button action-button"
                          v-b-modal="`submitProjectBudgetModal-${budgetYear.year}`">
                          Submit Budget
                        </b-button>
                      </div>
                    </div>
                    <ProductTable
                      :budgetYear = "budgetYear"
                      productType = 'service'
                      :getProductsFromListItems = "getServicesFromListItems"
                      :getFundingSource = "getFundingSource"
                      :editLineItem = "editLineItem"
                      :deleteLineItem = "deleteLineItem"
                      :getTotalCost = "getTotalCost"
                      :getCostShareAmt = "getCostShareAmt"
                    />
                    <div class="list-item-title">Materials</div>
                    <ProductTable
                      :budgetYear = "budgetYear"
                      productType = 'material'
                      :getProductsFromListItems = "getMaterialsFromListItems"
                      :getFundingSource = "getFundingSource"
                      :editLineItem = "editLineItem"
                      :deleteLineItem = "deleteLineItem"
                      :getTotalCost = "getTotalCost"
                      :getCostShareAmt = "getCostShareAmt"
                    />
                    <div v-if="incentivesExistInBudgetYear(budgetYear, projectIncentivePayments)">
                      <div class="list-item-title">Incentive Payments</div>
                      <IncentivePaymentsTable
                        :budgetYear = "budgetYear"
                        :projectIncentivePayments = "projectIncentivePayments"
                        :getProductsFromListItems = "getIncentivesFromListItems"
                        :contactBriefs = "contactBriefs"
                        :organizationBriefs = "organizationBriefs"
                        :fundingSources = "fundingSources"
                      />
                    </div>
                    <div class="list-item-title">Annual Cost</div>
                    <AnnualBudgetTable
                      :budgetYear="budgetYear"
                      :getAnnualBudgetItems = "getAnnualBudgetItems"
                    />
                  </b-tab>
                  <b-tab
                    title="Annual Budget History"
                    v-if="budgetYear.status === budgetStatus.Approved">
                    <AnnualBudgetIncreases
                      :key="historyKey"
                      :budgetYear="budgetYear"
                    />
                  </b-tab>
                </b-tabs>
              </div>
            </b-overlay>
          </b-collapse>
        </div>
      </div>
    </div>
    <ProjectWorkorderAdd
      v-if='projectWorkorderAddIsVisible'
      :budgetYear='budgetYear'
      :contactBriefs="contactBriefs"
      :fundingSources="fundingSources"
      :opportunityBriefs="opportunityBriefs"
      :organizationBriefs="organizationBriefs"
      :project="project"
      :projectBudget="projectBudget"
    />
  </div>
</template>
<script>
/* eslint-disable max-len, padded-blocks */
import { mapState } from 'vuex';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';
import AnnualBudgetIncreases from '@/components/projects/AnnualBudgetIncreases.vue';
import AnnualBudgetIncreaseModal from '@/components/projects/AnnualBudgetIncreaseModal.vue';
import ProductTable from '@/components/projects/ProductTable.vue';
import IncentivePaymentsTable from '@/components/projects/IncentivePaymentsTable.vue';
import AnnualBudgetTable from '@/components/projects/AnnualBudgetTable.vue';
import AlertManager from '@/mixins/AlertManager';
import ProjectApprovalMembershipManager from '@/mixins/projectApprovalMembershipManager';
import ProjectBudgetHelper from '@/mixins/projectBudgetHelper';
import ProjectBudgetHelperExpenditureSummary from '@/mixins/projectBudgetHelperExpenditureSummary';
import ProjectBudgetMembershipManager from '@/mixins/projectBudgetMembershipManager';
import ProjectSchemaHelper from '@/mixins/projectSchemaHelper';
import ProjectTotalsCalculator from '@/mixins/projectTotalsCalculator';
import ProjectWorkOrderBillingManager from '@/mixins/projectWorkOrderBillingManager';
import ProjectWorkorderAdd from '@/components/projects/ProjectWorkorderAdd.vue';
import FiscalYear from '@/mixins/fiscalYear';

export default {
  name: 'AnnualBudget',
  props: {
    budgetYear: Object,
  },
  data() {
    return {
      currentLineItem: this.initLineItem(),
      fundingSourceBudgets: [],
      historyKey: 0,
      insufficientFundingSources: [],
      insufficientFundingSourcesAcrossProjects: [],
      processingApproval: false,
      projectWorkorderAddIsVisible: false,
      validForm: false,
      funds: [],
      loadingPriceBookData: false,
      // yearSubtotal: 0,
    };
  },
  components: {
    AnnualBudgetIncreases,
    AnnualBudgetIncreaseModal,
    LoadingSpinner,
    ProductTable,
    IncentivePaymentsTable,
    AnnualBudgetTable,
    ProjectWorkorderAdd,
  },
  mixins: [
    AlertManager,
    ProjectApprovalMembershipManager,
    ProjectBudgetHelper,
    ProjectBudgetHelperExpenditureSummary,
    ProjectBudgetMembershipManager,
    ProjectSchemaHelper,
    ProjectTotalsCalculator,
    ProjectWorkOrderBillingManager,
    FiscalYear,
  ],
  computed: {
    ...mapState('Project', {
      currentPriceLists: (state) => state.currentPriceLists,
      encumberedFundsForApprovedBudgets: (state) => state.encumberedFundsForApprovedBudgets,
      errorMessage: (state) => state.errorMessage,
      fundingSources: (state) => state.fundingSources,
      fundsPerFiscalYear: (state) => state.fundsPerFiscalYear.funds,
      hasOpenWorkOrders: (state) => state.hasOpenWorkOrders,
      hasOpenWorkOrderBills: (state) => state.hasOpenWorkOrderBills,
      currentPriceListsLoading: (state) => state.currentPriceListsLoading,
      priceLists: (state) => state.priceLists,
      products: (state) => state.products,
      project: (state) => state.project,
      projectBudgetYearSnapshots: (state) => state.projectBudgetYearSnapshots,
      projectSnapshot: (state) => state.projectSnapshot,
      projectFiscalYearSnapshots: (state) => state.projectFiscalYearSnapshots,
      projectWorkorders: (state) => state.projectWorkorders,
      projectWorkorderBills: (state) => state.projectWorkorderBills,
      projectWorkorderLineItemFundingSources: (state) => state.projectWorkorderLineItemFundingSources,
      projectBudgetSummaryDataLoaded: (state) => state.projectBudgetSummaryDataLoaded,
      projectSnapshotDraft: (state) => state.projectSnapshotDraft,
      projectIncentivePayments: (state) => state.projectIncentivePayments,
      incentiveTypes: (state) => state.incentiveTypes,
    }),
    ...mapState('Contact', {
      contactBriefs: (e) => e.contactBriefs,
    }),
    ...mapState('Opportunity', {
      opportunityBriefs: (e) => e.workorderOpportunityBriefs,
    }),
    ...mapState('Organization', {
      organizationBriefs: (e) => e.organizationBriefs,
    }),
    workorderLookupsLoading() {
      if (!this.contactBriefs || this.contactBriefs === null || this.contactBriefs.length === 0) return true;
      if (!this.opportunityBriefs || this.opportunityBriefs === null || this.opportunityBriefs.length === 0) return true;
      if (!this.organizationBriefs || this.organizationBriefs === null || this.organizationBriefs.length === 0) return true;
      return false;
    },
    validateAfterLoad() {
      return this.currentLineItem.id && this.currentLineItem.id !== null;
    },
  },
  mounted() {
    this.setExistingFunds(this.budgetYear);
  },
  methods: {
    initLineItem() {
      return {
        product: null,
        priceListId: null,
        targetDate: new Date(),
        unitCost: null,
        units: null,
        quantity: null,
        fundingSourceId: null,
        costShare: 100,
        notes: '',
        contingencyPercent: 10,
      };
    },
    async getPaidBillAmountForFundingSource() {
      if (!this.projectWorkorders || this.projectWorkorders == null) {
        await this.$store.dispatch('Project/getProjectWorkorders', parseInt(this.$route.params.id, 10));
      }
      if (!this.projectWorkorderBills || this.projectWorkorderBills == null) {
        await this.$store.dispatch(
          'Project/getProjectWorkorderBills',
          this.projectWorkorders.map((e) => e.id),
        );
      }

      const billsByFundingSource = this.projectWorkorderBills.filter((e) => e.status === 'Paid')
        .map((bill) => this.getBillPaymentTotalByFundingSource(bill));

      const billsByFundingSourceFlat = billsByFundingSource.flat(1);

      const totalSpentByFundingSource = {};

      const fundingSourceIds = Array.from(new Set(
        billsByFundingSourceFlat.map(
          (e) => e.id,
        ),
      ));

      fundingSourceIds.forEach((e) => {
        totalSpentByFundingSource[e.toString()] = 0;
      });

      billsByFundingSourceFlat.forEach((e) => {
        totalSpentByFundingSource[e.id.toString()] += e.amount;
      });

      const totalSpentItems = fundingSourceIds.map((e) => {
        const itemCost = totalSpentByFundingSource[e.toString()];
        return {
          id: e,
          total: itemCost,
        };
      });

      return totalSpentItems;
    },
    async getIncentivePaymentsAmount() {
      await this.$store.dispatch('Project/getProjectIncentivePayments', this.project.id);
      return this.projectIncentivePayments
        .filter((payment) => payment.datePaid !== null)
        .map((payment) => payment.amountPaid)
        .reduce((accumulator, currentValue) => accumulator + currentValue, 0.0);
    },
    async validateFundsAcrossProjects(budgetYear) {
      const vm = this;

      const budgetYearFundingSources = this.getBudgetYearFundingSummary(budgetYear);

      const fundingSourceIds = budgetYearFundingSources.map((fs) => fs.id);

      await this.$store.dispatch('Project/getProjectSnapshotsByFiscalYear', budgetYear.year);
      const projectSnapshotsByFundingSource = await this.getProjectSnapshotByFundingSourceAcrossProjects(this.project.id, budgetYear.year, fundingSourceIds);

      const projectSnapshotsByFundingSourceFiltered = projectSnapshotsByFundingSource.map((psfs) => {
        const encumberedFundsObject = {
          id: psfs.id,
          budget: psfs.totalRequested,
        };

        return encumberedFundsObject;
      });

      await this.$store.dispatch('Project/getFundsPerFiscalYear', budgetYear.year).then(() => {
        let fundingSourceBudgets = vm.fundsPerFiscalYear.filter(
          (e) => (e.customfields.find((field) => field.fielD_NAME === 'Funding_Source__c')) && (e.customfields.find((field) => field.fielD_NAME === 'Approved_Projects_Budget__c')),
        );

        fundingSourceBudgets = fundingSourceBudgets.map((e) => {
          const fundingSourceBudget = {
            id: e.customfields.find((field) => field.fielD_NAME === 'Funding_Source__c').fielD_VALUE,
            budget: e.customfields.find((field) => field.fielD_NAME === 'Approved_Projects_Budget__c').fielD_VALUE,
          };
          return fundingSourceBudget;
        }).sort((a, b) => a.id - b.id);

        vm.fundingSourceBudgets = fundingSourceBudgets;
      });

      vm.insufficientFundingSourcesAcrossProjects = vm.getYearInsufficientFundingSourcesAcrossProjects(budgetYear, projectSnapshotsByFundingSourceFiltered);
    },
    async validateFundsWithinProject(budgetYear) {
      const vm = this;

      const budgetYearFundingSources = this.getBudgetYearFundingSummary(budgetYear);

      const fundingSourceIds = budgetYearFundingSources.map((fs) => fs.id);

      const projectSnapshotsByFundingSource = await this.getProjectSnapshotByFundingSource(this.project.id, fundingSourceIds);

      const projectSnapshotsByFundingSourceFiltered = projectSnapshotsByFundingSource.map((psfs) => {
        const encumberedFundsObject = {
          id: psfs.id,
          budget: psfs.totalRequested,
        };

        return encumberedFundsObject;
      });

      const billAmount = await this.getPaidBillAmountForFundingSource();

      vm.insufficientFundingSources = vm.getYearInsufficientFundingSources(budgetYear, budgetYearFundingSources, projectSnapshotsByFundingSourceFiltered, billAmount);
    },
    async getProjectSnapshotByFundingSourceAcrossProjects(projectId, budgetYear, fundingSourceIds) {

      const fundingSourceLineItems = [];

      this.projectFiscalYearSnapshots.filter((projectSnapshot) => projectSnapshot.projectId !== projectId).forEach((projectSnapshot) => {
        if (projectSnapshot.projectBudgetYearSnapshots) {
          projectSnapshot.projectBudgetYearSnapshots.filter((projectBudgetYearSnapshot) => projectBudgetYearSnapshot.year === budgetYear && projectBudgetYearSnapshot.status === 'Approved')
            .forEach((projectBudgetYearSnapshot) => {
              if (projectBudgetYearSnapshot.projectBudgetLineItemSnapshots) {
                projectBudgetYearSnapshot.projectBudgetLineItemSnapshots.filter(
                  (projectBudgetLineItemSnapshot) => fundingSourceIds.includes(projectBudgetLineItemSnapshot.fundingSourceId),
                ).forEach(
                  (projectBudgetLineItemSnapshot) => {
                    const fundingSourceLineItem = {
                      projectId: projectSnapshot.projectId,
                      fundingSourceId: projectBudgetLineItemSnapshot.fundingSourceId,
                      quantity: projectBudgetLineItemSnapshot.quantity,
                      unitCost: projectBudgetLineItemSnapshot.unitCost,
                      costShare: projectBudgetLineItemSnapshot.costShare,
                      contingencyPercent: projectBudgetLineItemSnapshot.contingencyPercent,
                      itemCost: 0,
                    };

                    const itemCost = fundingSourceLineItem.quantity * (fundingSourceLineItem.unitCost * 100);
                    const costShare = fundingSourceLineItem.costShare * 0.01;
                    const contingency = 1 + (fundingSourceLineItem.contingencyPercent * 0.01);

                    /* eslint-disable-next-line */
                    fundingSourceLineItem.itemCost = Math.round((itemCost * costShare) * contingency) / Math.pow(10, 2);
                    fundingSourceLineItems.push(fundingSourceLineItem);
                  },
                );
              }
            });
        }
      });

      const encumberedFundsIds = [...new Set(fundingSourceLineItems.map((e) => e.fundingSourceId))];

      const encumberedFundsObjects = encumberedFundsIds.map((e) => {
        const encumberedFundsObject = {
          id: e,
          budget: 0,
        };

        const lineItems = fundingSourceLineItems.filter((lineItem) => lineItem.fundingSourceId === e);

        if (lineItems) {
          encumberedFundsObject.totalRequested = lineItems.map((lineItem) => lineItem.itemCost).reduce((a, b) => a + b);
        }

        return encumberedFundsObject;
      });

      return encumberedFundsObjects;
    },
    async getProjectSnapshotByFundingSource(projectId, fundingSourceIds) {

      const fundingSourceLineItems = [];

      if (this.projectSnapshotDraft.projectBudgetYearSnapshots) {
        this.projectSnapshotDraft.projectBudgetYearSnapshots.forEach((projectBudgetYearSnapshot) => {

          if (projectBudgetYearSnapshot.projectBudgetLineItemSnapshots) {
            projectBudgetYearSnapshot.projectBudgetLineItemSnapshots.filter(
              (projectBudgetLineItemSnapshot) => fundingSourceIds.includes(projectBudgetLineItemSnapshot.fundingSourceId),
            ).forEach(
              (projectBudgetLineItemSnapshot) => {
                const fundingSourceLineItem = {
                  projectId: this.projectSnapshotDraft.projectId,
                  fundingSourceId: projectBudgetLineItemSnapshot.fundingSourceId,
                  quantity: projectBudgetLineItemSnapshot.quantity,
                  unitCost: projectBudgetLineItemSnapshot.unitCost,
                  costShare: projectBudgetLineItemSnapshot.costShare,
                  contingencyPercent: projectBudgetLineItemSnapshot.contingencyPercent,
                  itemCost: 0,
                };

                const itemCost = fundingSourceLineItem.quantity * (fundingSourceLineItem.unitCost * 100);
                const costShare = fundingSourceLineItem.costShare * 0.01;
                const contingency = 1 + (fundingSourceLineItem.contingencyPercent * 0.01);

                /* eslint-disable-next-line */
                fundingSourceLineItem.itemCost = Math.round((itemCost * costShare) * contingency) / Math.pow(10, 2);
                fundingSourceLineItems.push(fundingSourceLineItem);
              },
            );
          }
        });
      }

      const encumberedFundsIds = [...new Set(fundingSourceLineItems.map((e) => e.fundingSourceId))];

      const encumberedFundsObjects = encumberedFundsIds.map((e) => {
        const encumberedFundsObject = {
          id: e,
          budget: 0,
        };

        const lineItems = fundingSourceLineItems.filter((lineItem) => lineItem.fundingSourceId === e);

        if (lineItems) {
          encumberedFundsObject.totalRequested = lineItems.map((lineItem) => lineItem.itemCost).reduce((a, b) => a + b);
        }

        return encumberedFundsObject;
      });

      return encumberedFundsObjects;
    },
    async validateAnnualBudgetForApproval(budgetYear) {
      const vm = this;
      vm.processingApproval = true;

      await this.$store.dispatch('Project/anyOpenWorkOrders', this.project.id).then(async () => {
        if (this.hasOpenWorkOrders) {
          vm.processingApproval = false;
          vm.$bvModal.show('openWorkOrdersModal');
        }
      });

      if (vm.processingApproval) {
        await this.$store.dispatch('Project/anyOpenWorkOrderBills', this.project.id).then(async () => {
          if (this.hasOpenWorkOrderBills) {
            vm.processingApproval = false;
            vm.$bvModal.show('openWorkOrderBillsModal');
          }
        });
      }

      if (vm.processingApproval) {
        if (!['ECREP Project', 'Invasive Treatment Project', 'VEGBAC Project', 'Conservation Easement'].includes(this.project.category)) {

          await this.validateFundsWithinProject(budgetYear);

          if (vm.insufficientFundingSources.length > 0) {
            vm.$bvModal.show(`yearInsufficientFundsWithinProjectModal-${budgetYear.year}`);
            vm.processingApproval = false;
          }
        }
      }

      if (vm.processingApproval) {

        await this.validateFundsAcrossProjects(budgetYear);

        if (vm.insufficientFundingSourcesAcrossProjects.length > 0) {
          vm.$bvModal.show(`yearInsufficientFundsAcrossProjectModal-${budgetYear.year}`);
          vm.processingApproval = false;
        }
      }

      if (vm.processingApproval) {
        vm.$bvModal.show(`approveProjectBudgetModal-${budgetYear.year}`);
      }

      vm.processingApproval = false;
    },
    getProjectBudgetHref() {
      // force the last part of the path to the overview page
      return `${window.location.href.slice(0, window.location.href.lastIndexOf('/'))}/budget`;
    },
    async approveAnnualBudget(budgetYear) {
      /* eslint-disable-next-line */
      budgetYear.status = this.budgetStatus.Approved;
      this.$store.dispatch('Project/updateProjectBudgetYear', { year: budgetYear, projectSnapshotId: this.projectSnapshot.id });
      await this.loadProjectBudgetSummaryData();
      await this.loadProjectTotalsSummaryData();
      // increment key for AnnualBudgetIncreases component so it is re-rendered
      this.historyKey += 1;
      window.location.href = `mailto:${this.project.projectManager.emailAddress}?subject=Annual Budget Approved&body=${this.project.projectName}: ${this.getProjectBudgetHref()}`;
    },
    rejectAnnualBudget(budgetYear) {
      /* eslint-disable-next-line */
      budgetYear.status = this.budgetStatus.Rejected;
      this.$store.dispatch('Project/updateProjectBudgetYear', { year: budgetYear, projectSnapshotId: this.projectSnapshot.id });
      window.location.href = `mailto:${this.project.projectManager.emailAddress}?subject=Annual Budget Rejected&body=${this.project.projectName}: ${this.getProjectBudgetHref()}`;
    },
    submitAnnualBudget(budgetYear) {
      /* eslint-disable-next-line */
      budgetYear.status = this.budgetStatus.SubmittedForApproval;
      this.$store.dispatch('Project/updateProjectBudgetYear', { year: budgetYear, projectSnapshotId: this.projectSnapshot.id });
    },
    getYearAmountByFundingSource(budgetYear) {
      return budgetYear.projectBudgetLineItems.reduce((res, value) => {
        const existingEntry = res.find((r) => r.id === value.fundingSourceId);
        const lineItemCostSharePercent = 0.01 * value.costShare;
        const lineItemContingencyPercent = 0.01 * value.contingencyPercent;

        const lineItemCost = parseFloat((value.unitCost * value.quantity * lineItemCostSharePercent)
          + ((value.unitCost * value.quantity * lineItemCostSharePercent) * lineItemContingencyPercent));

        const lineItemCostFixed = parseFloat(lineItemCost.toFixed(2));

        if (!existingEntry) {
          res.push({ id: value.fundingSourceId, amount: lineItemCostFixed });
        } else {
          existingEntry.amount += lineItemCostFixed;
          existingEntry.amount = parseFloat(existingEntry.amount.toFixed(2));
        }
        return res;
      }, []);
    },
    getYearInsufficientFundingSourcesAcrossProjects(budgetYear, projectSnapshotsByFundingSource) {
      const vm = this;
      const currentYearFundingAmounts = vm.getYearAmountByFundingSource(budgetYear);

      const results = currentYearFundingAmounts.map((funding) => {

        const fundingSource = vm.getOrInitializeBudget(
          vm.fundingSourceBudgets,
          funding.id,
        );

        const encumberedFunds = vm.getOrInitializeBudget(
          projectSnapshotsByFundingSource,
          funding.id,
        );

        return {
          fundingSourceName: vm.fundingSources.find((e) => e.recorD_ID === funding.id).recorD_NAME,
          totalApprovedProjectsBudget: fundingSource.budget,
          encumberedAcrossProjects: encumberedFunds.budget,
          remaining: fundingSource.budget - encumberedFunds.budget,
          requested: funding.amount,
          difference: parseFloat(fundingSource.budget.toFixed(2)) - parseFloat(encumberedFunds.budget.toFixed(2)) - parseFloat(funding.amount.toFixed(2)),
        };

      }).filter(
        (funding) => funding.difference < 0,
      );

      return results;
    },
    getYearInsufficientFundingSources(budgetYear, budgetYearFundingSources, projectSnapshotsByFundingSource, billAmount) {
      const vm = this;

      const increases = this.projectBudget.projectBudgetYears.flatMap((pby) => pby.annualBudgetIncreases);
      const decreases = this.projectBudget.projectBudgetDecreases;

      // need to total all amounts requested for each fundingSource on this AnnualBudget
      const currentYearFundingAmounts = vm.getYearAmountByFundingSource(budgetYear);

      // see if this AnnualBudget puts any FundingSource over its approved budget
      // and just return the names of any that do exceed their budget
      const results = currentYearFundingAmounts.map((funding) => {

        const encumberedFunds = vm.getOrInitializeBudget(
          projectSnapshotsByFundingSource,
          funding.id,
        );

        const expendedFunds = vm.getOrInitializeExpendedFunds(
          billAmount,
          funding.id,
        );

        const fyIincreases = increases.filter((pby) => pby.fundingSourceId === funding.id);
        const fyIincreaseValues = fyIincreases.map(
          (ba) => ba.adjustmentToProjectBudget,
        );
        const fyIincreaseTotal = fyIincreaseValues.reduce(
          (a, b) => a + b, 0.0,
        );

        const fyDecreases = decreases.filter((pby) => pby.fundingSourceId === funding.id);
        const fyDecreaseValues = fyDecreases.map(
          (ba) => ba.decreaseAmount,
        );
        const fyDecreaseTotal = fyDecreaseValues.reduce(
          (a, b) => a + b, 0.0,
        );

        const increase = fyIincreaseTotal ?? 0;
        const decrease = fyDecreaseTotal ?? 0;
        const encumbered = encumberedFunds.budget + increase - decrease;

        return {
          fundingSourceName: vm.fundingSources.find((e) => e.recorD_ID === funding.id).recorD_NAME,
          totalApprovedFunding: encumbered,
          encumberedInProject: expendedFunds.total,
          remaining: encumbered - expendedFunds.total,
          requested: funding.amount,
          difference: parseFloat(encumbered.toFixed(2)) - parseFloat(expendedFunds.total.toFixed(2)) - parseFloat(funding.amount.toFixed(2)),
        };

      }).filter(
        (funding) => funding.difference < 0,
      );

      return results;
    },
    openCostItemModal(year) {
      const fiscalYear = year.year;
      this.currentLineItem.fiscalYear = fiscalYear;
      this.currentLineItem.fiscalYearStart = new Date(fiscalYear - 1, 6, 1);
      this.currentLineItem.fiscalYearEnd = new Date(fiscalYear, 6, 1);
      this.currentLineItem.projectBudgetYearId = year.id;
      this.currentLineItem.targetDate = this.currentLineItem.fiscalYearStart;
      this.currentLineItem.year = fiscalYear;
      this.validForm = this.currentLineItem.id;
      this.$bvModal.show(`costItemModal-${fiscalYear}`);
    },
    cancelCostItem() {
      this.currentLineItem = this.initLineItem();
    },
    isService(listItem) {
      const product = this.products.find((pl) => pl.producT_ID === listItem.costItemId);
      if (!product) {
        return false;
      }
      const type = product.customfields
        .find((cf) => cf.fielD_NAME === 'Type__c');
      if (!type) {
        return false;
      }
      return type.fielD_VALUE === 'Contracted Services';
    },
    getServicesFromListItems(listItems) {
      return listItems.filter((li) => this.isService(li));
    },
    getMaterialsFromListItems(listItems) {
      return listItems.filter((li) => !this.isService(li));
    },
    incentivesExistInBudgetYear(budgetYear, projectIncentivePayments) {
      const incentivePaymentsInBudgetYear = this.getIncentivesFromListItems(budgetYear.year, projectIncentivePayments);
      return incentivePaymentsInBudgetYear.length !== 0;
    },
    getIncentivesFromListItems(year, projectIncentivePayments) {
      const incentivePaymentsInBudgetYear = projectIncentivePayments.filter((pi) => {
        const incentiveFiscalYear = this.getFiscalYear(pi.dateDue);
        if (incentiveFiscalYear === year) return true;
        return false;
      });

      return incentivePaymentsInBudgetYear;
    },
    getYearFromId(id) {
      return this.projectBudget.projectBudgetYears.find((pby) => pby.id === id).year;
    },
    async addItem() {
      // get product and price info on the object for viewing once added to the ui
      this.currentLineItem.costItemId = this.currentLineItem.product.producT_ID;
      this.currentLineItem.totalCost = this.currentLineItem.unitCost
        * this.currentLineItem.quantity;
      this.$bvModal.hide(`costItemModal-${this.getYearFromId(this.currentLineItem.projectBudgetYearId)}`);
      await this.$store.dispatch('Project/saveProjectBudgetLineItem', this.currentLineItem);
      if (this.errorMessage) {
        this.showWarningAlert();
      } else {
        this.showSuccessAlert();
        this.$store.dispatch('Project/fetchProjectBudget', parseInt(this.$route.params.id, 10));
        this.currentLineItem = this.initLineItem();
      }
    },
    async editLineItem(row) {
      this.currentLineItem = { ...row.item };
      this.$bvModal.show(`costItemModal-${this.getYearFromId(this.currentLineItem.projectBudgetYearId)}`);
      this.loadingPriceBookData = true;
      await this.filterPriceLists();
      this.loadingPriceBookData = false;
    },
    deleteLineItem(row) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this line item?', { cancelVariant: 'danger' })
        .then((value) => {
          if (value) {
            this.$store.dispatch('Project/deleteProjectBudgetLineItem', row.item);
          }
        })
        .catch(() => {
          // An error occurred
        });
    },
    async filterPriceLists() {
      const unit = this.currentLineItem.product.customfields.find((cf) => cf.fielD_NAME === 'Unit__c');
      if (unit) this.currentLineItem.units = unit.fielD_VALUE;
      await this.$store.dispatch(
        'Project/fetchProductPriceListEntries',
        this.currentLineItem.product.producT_ID,
      );
    },
    onLineItemValidation(isValid) {
      this.validForm = isValid
        && this.currentLineItem.product
        && this.currentLineItem.fundingSourceId
        && this.currentLineItem.unitCost
        && this.currentLineItem.unitCost > 0
        && this.currentLineItem.quantity
        && this.currentLineItem.quantity > 0;
    },
    getOrInitializeBudget(fundingList, fundingSourceId) {
      const budget = { budget: 0.0 };
      const budgets = fundingList.filter((e) => e.id === fundingSourceId) || [];

      if (budgets && budgets.length > 0) {
        budget.budget = budgets.map((e) => e.budget).reduce((a, b) => a + b);
      }

      return budget;
    },
    getOrInitializeExpendedFunds(expendedFundsList, fundingSourceId) {
      const expendedFunds = expendedFundsList.find((e) => e.id === fundingSourceId) || { total: 0.0 };
      return expendedFunds;
    },
    canCreateWorkorder(budgetYear) {
      if (!this.project) {
        return false;
      }
      if ((this.project.approvalStatus === 'Completed' || this.project.approvalStatus === 'Cancelled')) {
        return false;
      }
      const canCreateWorkorder = (this.isWorkOrderSubmitter) && (budgetYear.status === 'Approved');
      return canCreateWorkorder;
    },
    onWorkorderAddClick(budgetYear) {
      const budgetModel = {
        fiscalYear: budgetYear.year,
        totalBudgeted: this.getAnnualBudgetExpenditureTotalAnnualCost(budgetYear),
        totalObligated: this.getAnnualBudgetExpenditureTotalObligated(budgetYear.year),
      };

      this.projectWorkorderAddIsVisible = false;
      this.$store.dispatch('Workorder/setBudgetModel', budgetModel).then(() => {
        this.projectWorkorderAddIsVisible = true;
      });
    },
    showAnnualExpenditureSummary() {
      return this.budgetYear.status === this.budgetStatus.Approved;
    },
    onAnnualBudgetInsufficientFundsDismiss(budgetYear) {
      console.debug('budgetYear: ', budgetYear);
    },
    onAnnualBudgetInsufficientFundsOverride(budgetYear) {
      this.approveAnnualBudget(budgetYear);
    },
  },
};
</script>
